/**
 * 満足度の顔アイコンを表示する（表示専用）
 *
 * level (1-5) に対応する顔アイコンを表示する。
 * null の場合は何も表示しない。
 */

const EMOJIS = [
  '',
  '\u{1F61E}',
  '\u{1F615}',
  '\u{1F610}',
  '\u{1F642}',
  '\u{1F60A}',
] as const

interface SatisfactionEmojiProps {
  level: number | null
  size?: 'xs' | 'sm' | 'md'
}

const SIZE_CLASSES = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
} as const

export function SatisfactionEmoji({
  level,
  size = 'sm',
}: SatisfactionEmojiProps) {
  if (level === null || level === undefined || level < 1 || level > 5)
    return null

  return (
    <span
      className={SIZE_CLASSES[size]}
      role="img"
      aria-label={`満足度 ${level}`}
    >
      {EMOJIS[level]}
    </span>
  )
}
